import { ErrorMessage, Field } from "formik";
import { IMAGE_BASE_URL, IMAGE_URL } from "../../config";
import cameraIcon from "../../assets/icons/camera.svg";
import get from "lodash/get";
import set from "lodash/set";
import { useState } from "react";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormImageField = ({
  label = "imageField",
  labelClassName = "",
  name = "imageField",
  className = "",
  previewClassName = "",
  camera = false,
  closeShow = true,
  ...props
}) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (event, form, name) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", IMAGE_URL);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100);
        setUploadProgress(percent);
      }
    };

    xhr.onloadstart = () => {
      setIsUploading(true);
      setUploadProgress(0);
    };

    xhr.onload = () => {
      setIsUploading(false);
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        const filePath = response?.data?.filePath;
        const end_path = response?.data?.end_path;
        const fullUrl = end_path !="" && end_path?`${IMAGE_BASE_URL}${end_path}`:filePath;

        const updatedValues = { ...form.values };
        set(updatedValues, name, fullUrl);
        form.setValues(updatedValues);

        console.log(name, fullUrl, "Upload success");
      } else {
        console.error("Upload failed", xhr.statusText);
        alert("Image upload failed!");
      }
    };

    xhr.onerror = () => {
      setIsUploading(false);
      console.error("Error uploading image:", xhr.statusText);
      alert("An error occurred during upload!");
    };

    xhr.send(formData);
  };

  const handleRemoveImage = (form, name) => {
    const updatedValues = { ...form.values };
    set(updatedValues, name, "");
    form.setValues(updatedValues);
  };

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const file = get(form.values, name);
        const error = meta.touched && meta.error;

        return (
          <div className={`flex flex-col gap-1 ${className} w-full`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                  error ? "text-errorColor" : labelClassName
                }`}
              >
                {formatUnderscoreToSpace(label)}
              </label>
            )}

            <div className="md:w-[8rem] w-[5rem] md:h-[8.3rem] h-[5.3rem] relative overflow-hidden">
              {file ? (
                <div className="relative">
                  <img
                    crossorigin="anonymous" 
                    src={file}
                    alt="Uploaded"
                    className={`md:w-[8rem] w-[5rem] md:h-[8rem] h-[5rem] rounded-lg  object-contain ${previewClassName}`}
                  />
                  {closeShow && (
                    <button
                      type="button"
                      onClick={() => handleRemoveImage(form, name)}
                      className="absolute top-0 right-0 bg-gray-400 text-white rounded-full p-[1px] px-[6px] text-xs hover:bg-gray-600"
                      title="Remove image"
                    >
                      x
                    </button>
                  )}
                </div>
              ) : (
                <label className="cursor-pointer">
                  <div
                    className={`border-[1.5px] md:w-[8rem] w-[5rem] md:h-[8rem] h-[5rem] flex items-center justify-center rounded-lg my-1 bg-white ${
                      error ? "border-errorColor" : "border-greyText"
                    }`}
                  >
                    {isUploading ? (
                      <div className="text-sm text-primary">
                        {uploadProgress}%
                      </div>
                    ) : (
                      <img src={cameraIcon} alt="Camera" />
                    )}
                  </div>
                  <input
                    name="file"
                    type="file"
                    className="invisible"
                    accept={camera ? "image/*" : "image/*"}
                    capture={camera ? "environment" : undefined}
                    onChange={(event) => handleFileChange(event, form, name)}
                  />
                </label>
              )}
            </div>

            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        );
      }}
    </Field>
  );
};
